import { CheckboxSelected, CheckboxUnselected } from '@/components/Checkbox/CheckboxComponents';
import { FilterOption } from '@/types/filters';
import React from 'react';
import ChevronIcon from '../FilterPanel/ChevronIcon';

interface FilterSectionProps {
  title: string;
  options: FilterOption[];
  selectedValues: string[];
  onToggle: (value: string, checked: boolean) => void;
  isOpen: boolean;
  onToggleSection: () => void;
  getSummaryText: (options: FilterOption[]) => string;
  shouldDisableSection: (options: FilterOption[]) => boolean;
  shouldDisableOption?: (option: FilterOption) => boolean;
}

const FilterSection: React.FC<FilterSectionProps> = ({
  title,
  options,
  selectedValues,
  onToggle,
  isOpen,
  onToggleSection,
  getSummaryText,
  shouldDisableSection,
  shouldDisableOption
}) => {
  const isDisabled = shouldDisableSection(options);

  return (
    <div className="pr-1">
      <button
        onClick={onToggleSection}
        disabled={isDisabled}
        className={`w-full flex items-center justify-between py-2 text-left ${
          isDisabled ? 'cursor-default' : 'cursor-pointer'
        }`}
        style={{ paddingTop: 8, paddingBottom: 8, gap: 12 }}
      >
        <div className="flex items-center gap-3 flex-1">
          <span className="text-base font-raleway font-normal tracking-[0.1em] text-[#1C1C1C]">
            {title}
          </span>
          <span className="flex-1 text-base font-raleway font-normal text-[#6C6C6C]">
            {getSummaryText(options)}
          </span>
        </div>
        {!isDisabled && (
          <ChevronIcon
            className={`transform transition-transform ${isOpen ? "" : "rotate-180"}`}
          />
        )}
      </button>
      {isOpen && (
        <div className="pb-3 pr-1 pt-3">
          <div className="space-y-3">
            {options.map((option, index) => {
              const value = String(option.rawValue || option.displayLabel);
              const isOptionDisabled = shouldDisableOption?.(option) || false;
              const isAllOption = option.rawValue === "all";
              
              return (
                <label
                  key={`${title.toLowerCase()}-${value}-${index}`}
                  className={`flex items-center space-x-3 py-2 ${
                    isOptionDisabled ? 'cursor-not-allowed opacity-50' : 'cursor-pointer'
                  } ${isAllOption ? 'pl-3' : 'pl-6'}`}
                  onClick={(e) => {
                    e.preventDefault();
                    if (!isOptionDisabled) {
                      onToggle(option.rawValue || option.displayLabel, !selectedValues.includes(value));
                    }
                  }}
                >
                  <div className="w-6 h-6 flex-shrink-0">
                    {selectedValues.includes(value) ? (
                      <CheckboxSelected className="w-6 h-6" />
                    ) : (
                      <CheckboxUnselected className="w-6 h-6" />
                    )}
                  </div>
                  <span className="text-sm font-raleway tracking-[0.1em]">{option.displayLabel}</span>
                </label>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
};

export default FilterSection; 